import { Link } from 'react-router-dom'
import './PricingTagStyle.css'
import React from 'react'

const PricingTag = () => {
  return (
    <div className='pricing'>
        <div className='card0'>
        <div className='card-container'>
            <div className='card1'>
                <h3>-Music Production-</h3>
                <span className='Bar'></span>
                <p className='monetary'> $100</p>
                <p>- Recording -</p>
                <p>- Beat making -</p>
                <p>- Mixing -</p>
                <p>- Mastering -</p>
                <Link to="/pay" className='Btn'>
                    BOOK NOW
                </Link>
            </div>
            <div className='card2'>
                <h3>-Software Services-</h3>
                <span className='Bar'></span>
                <p className='monetary'> $150</p>
                <p>- Presets data -</p>
                <p>- Complete Drum Sample~packs -</p>
                <p>- Complete Software Installation -</p>
                <p>- Complete Plugins Installation -</p>
                <Link to="/pay" className='Btn'>
                    PURCHASE NOW
                </Link>
            </div>
            <div className='card3'>
                <h3>-Web Premium-</h3>
                <span className='Bar'></span>
                <p className='monetary'> $300</p>
                <p>- 5 Days -</p>
                <p>- 8 Pages -</p>
                <p>- Featured -</p>
                <p>- Responsive Design -</p>
                <Link to="/pay" className='Btn'>
                    PURCHASE NOW
                </Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PricingTag